export const uniforms = () => {
    return {
        uFresnel: { value: 0.04 },
        uFresnelPower: { value: 3.0 },
    };
};

export const shaderChunks = {
    uniforms: /* glsl */ `
        uniform float uFresnel;
        uniform float uFresnelPower;
    `,
    functions: /* glsl */ `
        #ifndef FNC_FRESNEL
        #define FNC_FRESNEL
            float fresnel(float f0, float NoV, float power) {
                return f0 + (1.0 - f0) * pow(1.0 - NoV, power);
            }
        #endif
    `,
};
